<template>
  <nav class="platform-navbar">
    <router-link class="platform-logo" to="/">Vitrinis</router-link>
    <div class="platform-nav-links">
      <router-link to="/login">Log In</router-link>
      <router-link v-if="SIGNUP_OPEN" to="/signup" class="signup-link">Sign Up</router-link>
    </div>
  </nav>
</template>

<script>
// Hides the public Sign Up button; emailed invite links still work.
// Also set in PlatformFooter.vue.
const SIGNUP_OPEN = false

export default {
  name: 'PlatformNavbar',
  data() {
    return { SIGNUP_OPEN }
  }
}
</script>

<style scoped>
.platform-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  height: 56px;
  background: var(--color-admin-bg);
  border-bottom: 1px solid var(--color-light-gray);
  color: var(--color-admin-text);
}

/* Placeholder wordmark: plain type until the competition logo lands. */
.platform-logo {
  font-family: var(--font-vitrinis);
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--color-admin-text);
  text-decoration: none;
}

.platform-nav-links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.platform-nav-links a {
  color: var(--color-muted);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.2s;
}

.platform-nav-links a:hover {
  color: var(--color-admin-text);
}

.signup-link {
  background: var(--color-vitrinis);
  color: var(--color-white) !important;
  padding: 0.4rem 1.2rem;
  border-radius: var(--radius);
}

.signup-link:hover {
  opacity: 0.85;
}

@media (max-width: 400px) {
  .platform-navbar {
    padding: 0 1rem;
  }

  .platform-nav-links {
    gap: 0.75rem;
  }
}
</style>
